import React, { useEffect, useState } from 'react';
import './ProfileData.css'; // If you want to add custom styles
import Header from '../common/Header';
import { useNavigate } from "react-router-dom";
import httpService from '../../services/HttpService';

const ProfileData = () => {
    const navigate = useNavigate();
    const profileFields = {
        first_name: "",
        last_name: "",
        birthdate: "",
        phone: "",
        email: "",
        city: "",
        gender: ""
    };
    const [query, setQuery] = useState("");
    const [cities, setCities] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false); 
    const [profile, setProfile] = useState(profileFields);
    
    const [initialProfile, setInitialProfile] = useState(profileFields);

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const [isModified, setIsModified] = useState(false);
    const [notification, setNotification] = useState(null);

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const response = await httpService.get("/profile");
                const data = await response.json();
                setQuery(data.city?.name || '');
                const profileData = {
                    first_name: data.first_name || "",
                    last_name: data.last_name || "",
                    phone: data.phone || "",
                    email: data.email || "",
                    city: data.city?.name || "",
                    birthdate: data.birthdate || new Date().toISOString().split("T")[0],
                    gender: data.gender || ""
                };
                setProfile(profileData);
                setInitialProfile(profileData);
            } catch (err) {
                setError("Failed to load profile data.");
            } finally {
                setLoading(false);
            }
        };

        fetchProfile();
    }, []);

    useEffect(() => {
        if (query?.length < 2) {
            setCities([]);
            return;
        }

        const fetchCities = async () => {
            try {
                const response = await httpService.get(`/cities?search=${query}`);
                const data = await response.json();
                setCities(data);
            } catch (error) {
                console.error("Error fetching cities:", error);
            }
        };

        const debounce = setTimeout(fetchCities, 300);

        return () => clearTimeout(debounce);
    }, [query]);

    const handleSelectCity = (city) => {
        setProfile((prev) => ({ ...prev, city_id: city.id }));
        setQuery(city.name);
        setShowDropdown(false);
    };

    const handleClearInput = () => {
        setQuery('');
        setShowDropdown(false);
      };

    useEffect(() => {
        const hasChanges = Object.keys(profile).some(
            (key) => profile[key] !== initialProfile[key]
        );
        setIsModified(hasChanges);
    }, [profile, initialProfile]); 

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProfile((prevProfile) => {
            const updatedProfile = { ...prevProfile, [name]: value };
            setIsModified(JSON.stringify(updatedProfile) !== JSON.stringify(initialProfile));
            return updatedProfile;
        });
    };

    const handleSave = async () => {
        setSaving(true);
        setError(null);

        try {
            await httpService.put("/profile", profile);
            setNotification("Профиль успешно обновлен!");
            setTimeout(() => setNotification(null), 3000);
        } catch (err) {
            setError("Error updating profile.");
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <p></p>;
    // if (loading) return <p>Loading...</p>;
    if (error) return <p>{error}</p>;

    return (
        <>
            <Header />
            <main className="settings-main">
                <div className="profile-form">
                    <input
                        type="text"
                        name="first_name"
                        value={profile.first_name}
                        onChange={handleChange}
                        placeholder="Имя"
                    />

                    <input
                        type="text"
                        name="last_name"
                        value={profile.last_name}
                        onChange={handleChange}
                        placeholder="Фамилия"
                    />

                    <input
                        type="text"
                        name="phone"
                        value={profile.phone}
                        onChange={handleChange}
                        placeholder="Номер телефона"
                    />

                    <input
                        type="email"
                        name="email"
                        value={profile.email}
                        disabled
                        placeholder="Email"
                    />

                    <div className="city-select">
                        <input
                            type="text"
                            placeholder="Город"
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            onFocus={() => setShowDropdown(true)}
                        />
                        {query && (
                            <span
                            onClick={handleClearInput}
                            style={{
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                border: 'none',
                                cursor: 'pointer',
                            }}
                            >
                                x
                            </span>
                        )}
                        {showDropdown && cities?.length > 0 && (
                            <ul className={`dropdown ${showDropdown ? 'show' : ''}`}>
                                {cities.map((city) => (
                                    <li key={city.id} onClick={() => handleSelectCity(city)}>
                                        {city.name}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <input
                        type="date"
                        name="birthdate"
                        value={profile.birthdate}
                        onChange={handleChange}
                    />

                    <select style={{ color: profile.gender === "" ? "#aaa" : "#000" }} name="gender" value={profile.gender} onChange={handleChange}>
                        <option value="" disabled>Пол</option>
                        <option value="male">Мужской</option>
                        <option value="female">Женский</option>
                    </select>

                    <button onClick={handleSave} disabled={saving || !isModified}>
                        {saving ? "Сохранение..." : "Сохранить"}
                    </button>
                </div>
                {notification && (
                    <div className="notification">
                        {notification}
                    </div>
                )}
            </main>
        </>
    );
};

export default ProfileData;